var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrcFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48931_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.668 11.668H13.3346C12.4142 11.668 11.668 12.4142 11.668 13.3346V16.668C11.668 17.5884 12.4142 18.3346 13.3346 18.3346H16.668C17.5884 18.3346 18.3346 17.5884 18.3346 16.668V13.3346C18.3346 12.4142 17.5884 11.668 16.668 11.668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 8.33464C2.41797 8.33464 1.66797 7.58464 1.66797 6.66797V3.33464C1.66797 2.41797 2.41797 1.66797 3.33464 1.66797H6.66797C7.58464 1.66797 8.33464 2.41797 8.33464 3.33464",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33464 13.3346C7.41797 13.3346 6.66797 12.5846 6.66797 11.668V8.33464C6.66797 7.41797 7.41797 6.66797 8.33464 6.66797H11.668C12.5846 6.66797 13.3346 7.41797 13.3346 8.33464",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48931_2110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrcFilledV2);
export default __webpack_public_path__ + "static/media/grcFilledV2.0f24a83022f506a598a650335bb630d2.svg";
export { ForwardRef as ReactComponent };